import { useEffect, useMemo, useRef } from 'react';
import { ConfiguracionArchivoService } from '../../service/admin/ConfiguracionArchivoService';
import { useLazyParams } from '../../hooks/useLazyParams';
import { TablaDinamica } from '../../components/TablaDinamica';
import { RolArchivo as RolArchivoModel } from '../../models/administracion/RolArchivo';

export const RolArchivo = ({ id, toast, permss }) => {

    const rolService = useMemo(() => new ConfiguracionArchivoService(), []);
    const asignarRef = useRef(null);
    const rolArchivoConfig = useMemo(() => new RolArchivoModel(asignarRef, permss), [permss]);
    const tablaEstado = useLazyParams({ modelo: rolArchivoConfig.model });

    useEffect(() => {
        loadLazyData();
        // eslint-disable-next-line
    }, [tablaEstado.lazyParams, id]);

    const loadLazyData = () => {
        const params = { idc: id, ...tablaEstado.lazyParams };
        tablaEstado.setLoading(true);
        rolService.listaRol({ lazyEvent: JSON.stringify(params) }).then(res => {
            tablaEstado.setTotalRecords(res.data.total);
            tablaEstado.setData(res.data.registros);
        }).catch(error => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Error asignando el permiso', life: 3000 });
        }).finally(() => {
            tablaEstado.setLoading(false);
        });
    };

    const asignar = (e, rowData, opcion, campoDb) => {
        const checked = e.checked;
        const idr = rowData.idr;
        const loadingField = `loading_${campoDb}`; // Ej: loading_consultar
        // Activar solo el spinner de esta celda, inyectando el flag temporal en el Data Array
        tablaEstado.setData(prev => prev.map(row =>
            row.idr === idr ? { ...row, [loadingField]: true } : row
        ));

        rolService.asignarPermiso({ idr: idr, idc: id, estado: checked, opcion }).then(res => {
            // Quitamos el spinner y actualizamos el check de la fila localmente
            tablaEstado.setData(prev => prev.map(row =>
                row.idr === idr ? { ...row, [loadingField]: false, [campoDb]: checked } : row
            ));
            toast.current.show({ severity: 'success', summary: 'Exitoso', detail: res.data || 'Permiso actualizado', life: 3000 });
        }).catch(error => {
            // Quitamos el spinner, el checkbox se queda como estaba antes
            tablaEstado.setData(prev => prev.map(row =>
                row.idr === idr ? { ...row, [loadingField]: false } : row
            ));
            toast.current.show({ severity: 'error', summary: 'Error en el servidor', detail: 'Revise Logs', life: 3000 });
            // Opcionalmente se puede llamar a tablaEstado.refreshData() para sincronizar los datos del front en caso de error
        });
    };

    // Ref que pasa la función para que el modelo pueda llamar a asignar
    asignarRef.current = asignar;

    return (
        <TablaDinamica modelo={rolArchivoConfig.model} estadoTabla={tablaEstado} datos={tablaEstado.data} totalRegistros={tablaEstado.totalRecords} dataKey="idr" size="small" />
    );
};